import { render, staticRenderFns } from "./BorderBox8.vue?vue&type=template&id=6db45d7c"
import script from "./BorderBox8.vue?vue&type=script&lang=js"
export * from "./BorderBox8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports